import ViewConnected from './ViewConnected'
export default ViewConnected
